// extracted by mini-css-extract-plugin
export default {"CheckboxTable":"checkboxTable_CheckboxTable__pDqsH","checkbox-cell":"checkboxTable_checkbox-cell__7I3zY"};